import React from 'react';
import './waterDrop.css';  // Import the CSS file

const WaterDrop = () => {
  const handleWhatsAppClick = () => {
    // Replace the URL with the WhatsApp bot link
    window.open('https://api.whatsapp.com/send?phone=5217712423333&text=Hola', '_blank');
  };

  const handleQRClick = () => {
    // Replace the URL with the QR code link
    window.open('https://servicioscaasim.hidalgo.gob.mx/', '_blank');
  };

  return (
    <div className="container-water-drop">
      {/* Water Drop Robot Image */}
      <div className='container-water-drop-inside'>
        <img
          src="/assets/imgs/waterdrop/Gotin-Personaje.png"
          alt="Water Drop Robot"
          className="robotImage"
        />
        {/* WhatsApp Logo */}
        <img
          src="/assets/imgs/waterdrop/Gotin-LogoWhatsapp.png"
          alt="WhatsApp"
          className="whatsappImage"
          onClick={handleWhatsAppClick}
        />
      </div>
      <div className="codigo-qr-container">
      <img 
          src="/assets/imgs/waterdrop/codigo_qr.png"
          alt="QR Code para ir a Servicios en Linea"
          className="QRImage"
          onClick={handleQRClick}
        />
      </div>
    </div>
  );
};

export default WaterDrop;
